import { isFlagEnabled } from "js/utilities";
export const singlePolicyViewLinks = [
  {
    heading: "Manage Transactions",
    links: [
      {
        id: 1,
        name: "Make a Payment",
        route: "/payment",
      },
      {
        id: 2,
        name: "View Billing Statements",
        route: "/messages?tab=documents",
      },
      {
        id: 3,
        name: "View Transaction History",
        route: "?tab=payment",
      },
    ],
  },

  {
    heading: "Manage Contract",
    links: [
      {
        id: 1,
        name: "Quotes & Illustrations",
        route: "external",
      },
      {
        id: 2,
        name: "Update Contract Owner’s Contact Information",
        route: "/services-claims/forms",
      },
      {
        id: 3,
        name: "File a Claim",
        route: "/services-claims/claims/file-a-claim",
      },
      ...(isFlagEnabled("ENABLE_POLICY_DETAIL_PAGE_TO_RELATED_FORMS_PAGE")
        ? [
            {
              id: 3,
              name: "View Forms",
              route: "/services-claims/forms",
            },
          ]
        : []),
      {
        id: 5,
        name: "Fund Transfers",
        route: "/services-claims/forms",
      },
      {
        id: 6,
        name: "Fund Performance, Prospectuses & Fund Information",
        route: "",
      },
    ],
  },
  ...(isFlagEnabled(
    "ENABLE_AGENT_POLICY_DETAIL_PAGE_QUICK_LINK_TO_CORRESPONDENCE_PAGE"
  )
    ? [
        {
          heading: "Alerts & Documents",
          links: [
            {
              id: 1,
              name: "View Documents",
              route: "/messages?tab=documents",
            },

            {
              id: 2,
              name: "View Contract Alerts",
              route: "/messages?tab=contractAlerts",
            },
          ],
        },
      ]
    : []),
];
export const annuitySinglePolicyViewLinks = [
  {
    heading: "Transactions",
    links: [
      {
        id: 3,
        name: "View Transaction History",
        route: "?tab=payment",
      },
    ],
  },

  {
    heading: "Manage Contract",
    links: [
      {
        id: 1,
        name: "File a Claim",
        route: "/services-claims/claims/file-a-claim",
      },
      ...(isFlagEnabled("ENABLE_POLICY_DETAIL_PAGE_TO_RELATED_FORMS_PAGE")
        ? [
            {
              id: 2,
              name: "View Forms",
              route: "/services-claims/forms",
            },
          ]
        : []),
      {
        id: 3,
        name: "Fund Transfers",
        route: "/services-claims/forms",
      },
      {
        id: 4,
        name: "Fund Performance, Prospectuses & Fund Information",
        route: "",
      },
    ],
  },
  ...(isFlagEnabled(
    "ENABLE_AGENT_POLICY_DETAIL_PAGE_QUICK_LINK_TO_CORRESPONDENCE_PAGE"
  )
    ? [
        {
          heading: "Alerts & Documents",
          links: [
            {
              id: 1,
              name: "View Documents",
              route: "/messages?tab=documents",
            },

            {
              id: 2,
              name: "View Contract Alerts",
              route: "/messages?tab=contractAlerts",
            },
          ],
        },
      ]
    : []),
];
